import { render, staticRenderFns } from "./ListsTabs.vue?vue&type=template&id=2c07cb9f&"
import script from "./ListsTabs.vue?vue&type=script&lang=js&"
export * from "./ListsTabs.vue?vue&type=script&lang=js&"
import style0 from "./ListsTabs.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports